module.exports = __webpack_public_path__ + "static/media/on-internacional.d01036d8.png";